import moment from "moment-timezone";

export const formatDateTime = (isoString, timezone = "Asia/Seoul") => {
  return moment.utc(isoString).tz(timezone).format("YYYY-MM-DD HH:mm:ss");
}